export const communityColors: Record<string, string> = {
  black: "#000000",
  "0x8da4cb832907bf41a770cbadd460763ff1a55113c1c2ee99533ce8a80e138d87": "#000000",
  "0x6193e5151e8fde7f4ca2e16f31a42effe56cbafa126423941cbe7ff51a5143bd": "#448BF2",
  "0xa33a7c83cca23dca0537615282a89000e4d4c6d07b47d057c37d7b9f34b05d97": "#000000",
  "0x6b154a62b0b5d53bbded9c4f60131934ee2738596129bc658420664d26f1c785": "#206bd6",
  "0x4213c5a9efc98eea6aea52a1fbfc74fef758de750083de2572723c286ac4b5e2": "#FC031F",
  "0x838fa5fcdf99f4e6e28aef702d1780b155015602413c15e7242819e2e5dd0113": "#4cc38a",
  "0x5e85f26150e28595525573a8ed18a98049435256d1c93a7132079914864902be": "#ecf0f1",
};
